const { useState, useEffect } = require("react");

function debounce(fn, ms) {
    let timer;
    return _ => {
        clearTimeout(timer);
        timer = setTimeout(_ => {
            timer = null;
            // @ts-ignore
            fn.apply(this, arguments);
        }, ms);
    };
}

const useBreakPoint = (max = 768) => {
    const [dimension, setDimension] = useState([
        window.innerWidth,
        window.innerHeight,
    ]);

    useEffect(() => {
        const debouncedResizeHandler = debounce(() => {
            setDimension([window.innerWidth, window.innerHeight]);
        }, 5);
        window.addEventListener('resize', debouncedResizeHandler);
        return () => window.removeEventListener('resize', debouncedResizeHandler);
    }, []); 

    return { dimension, isBreakpointActive: dimension[0] < max }
}

export default useBreakPoint;
